const Footer = () => {
    return(
        <footer>
        Created by Chris, Beth, Frank + Nicky at <a href="https://junocollege.com" target="_blank" rel="noopener noreferrer">Juno College</a> 2021.
        </footer>   
    )
}

export default Footer;